var VerifyGiftCard;
(function (VerifyGiftCard) {
    document.addEventListener('ControllerReady', () => {
        var _a;
        const config = retrieveConfig(document);
        var step1 = document.getElementById('gift-card-input-container');
        var step2 = document.getElementById('gift-card-container');
        var errorDiv = document.getElementById('errorDiv');
        var listResultGiftCard = document.getElementById('cardDetail');
        var headerTitle = document.getElementById('gift-card-header');
        let btnConsulta = document.querySelector('.btnConsulta');
        let giftCardForm = document.getElementById('giftCardForm');
        giftCardForm === null || giftCardForm === void 0 ? void 0 : giftCardForm.addEventListener('submit', checkGiftCard);
        initializeUserInputs();
        setButtonStatus();
        (_a = document.querySelector('.consult-another-card')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', restartFlow);
        function checkGiftCard(e) {
            var _a, _b;
            e.preventDefault();
            let verifyCode = getCodeFromInputs('code-input');
            let panNumber = getCodeFromInputs('pan-input');
            var payload = { codice_web: verifyCode.toUpperCase(), codice_controllo: panNumber };
            (_a = document.getElementById('main')) === null || _a === void 0 ? void 0 : _a.setAttribute('data-spinner', 'mask');
            (_b = document.querySelector('body')) === null || _b === void 0 ? void 0 : _b.classList.add('scrollLock');
            sendHttpRequest('/api/getGiftCardInfo', 'POST', payload, callBackGiftCardInfo);
        }
        function restartFlow() {
            headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.classList.remove('d-none');
            step2 === null || step2 === void 0 ? void 0 : step2.classList.add('d-none');
            step1 === null || step1 === void 0 ? void 0 : step1.classList.remove('d-none');
            let inputs = document.querySelectorAll('input.circle-input');
            inputs.forEach(function (input) {
                let field = input;
                field.value = '';
                field.classList.remove('circle-input-error');
            });
            errorDiv === null || errorDiv === void 0 ? void 0 : errorDiv.classList.add('d-none');
            setButtonStatus();
        }
        function printGiftCardInfo(items) {
            listResultGiftCard.innerHTML = '';
            items.forEach(function (item) {
                let li = document.createElement('li');
                let strong = document.createElement('strong');
                strong.textContent = item.label + ": ";
                li.appendChild(strong);
                li.appendChild(document.createTextNode(item.value));
                listResultGiftCard === null || listResultGiftCard === void 0 ? void 0 : listResultGiftCard.appendChild(li);
            });
        }
        function callBackGiftCardInfo(response) {
            var _a, _b;
            errorDiv = document.getElementById('errorDiv');
            var giftCard = JSON.parse(response.data);
            if (giftCard.codice_stato.startsWith('00')) { 
                let dataScadenza = new Date(giftCard.data_scadenza);
                let dataAttivazione = new Date(dataScadenza);
                dataAttivazione.setFullYear(dataAttivazione.getFullYear() - 2);
                let items = [
                    { label: "Codice carta", value: giftCard.pan_verifica.replace(/(\d{4})(?=\d)/g, '$1-') },
                    { label: "Data di attivazione", value: formatDate(dataAttivazione) },
                    { label: "Scadenza", value: formatDate(dataScadenza) },
                    { label: "Importo Residuo", value: giftCard.residuo + " €" }
                ];
                headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.classList.add('d-none');
                printGiftCardInfo(items);
                errorDiv === null || errorDiv === void 0 ? void 0 : errorDiv.classList.add('d-none');
                step2 === null || step2 === void 0 ? void 0 : step2.classList.remove('d-none');
                step1 === null || step1 === void 0 ? void 0 : step1.classList.add('d-none');
                let inputs = document.querySelectorAll('input.circle-input');
                inputs.forEach(function (input) {
                    input.classList.remove('circle-input-error');
                });
            }
            else {
                headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.classList.remove('d-none');
                errorDiv === null || errorDiv === void 0 ? void 0 : errorDiv.classList.remove('d-none');
                step2 === null || step2 === void 0 ? void 0 : step2.classList.add('d-none');
                step1 === null || step1 === void 0 ? void 0 : step1.classList.remove('d-none');
                let inputs = document.querySelectorAll('input.circle-input');
                inputs.forEach(function (input) {
                    input.classList.add('circle-input-error');
                });
            }
            (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.remove('scrollLock');
            (_b = document.getElementById('main')) === null || _b === void 0 ? void 0 : _b.removeAttribute('data-spinner');
        }
        function formatDate(date) {
            let day = ("0" + date.getDate()).slice(-2);
            let month = ("0" + (date.getMonth() + 1)).slice(-2);
            let year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        function getCodeFromInputs(className) {
            let inputs = document.querySelectorAll('.' + className);
            let code = '';
            inputs.forEach(input => {
                let item = input;
                code += item.value;
            });
            return code;
        }
        function allInputValorized() {
            for (const element of document.querySelectorAll('.circle-input')) {
                const inputElement = element;
                if (inputElement.value === '') {
                    return false;
                }
            }
            return true;
        }
        function setButtonStatus() {
            if (allInputValorized()) {
                btnConsulta.removeAttribute('disabled');
            }
            else {
                btnConsulta.setAttribute('disabled', 'true');
            }
        }
        function initializeUserInputs() {
            document.querySelectorAll('.circle-input').forEach((element) => {
                const inputElement = element;
                inputElement.value = '';
                inputElement.addEventListener('keyup', (event) => {
                    if (event.key === 'Backspace') {
                        const prev = inputElement.previousElementSibling;
                        if (prev && prev.focus)
                            prev.focus();
                    }
                    else {
                        if (inputElement.value.length === 1) {
                            const next = inputElement.nextElementSibling;
                            if (next && next.focus)
                                next.focus();
                        }
                    }
                    setButtonStatus();
                });
            });
        }
        function retrieveConfig($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function sendHttpRequest(ServiceEndpoint, method, data, callback) {
            Fetch(ServiceEndpoint, {
                method: method,
                data: data,
                token: {
                    enable: true,
                },
            }).then(callback)
                .catch((err) => {
                console.error('Error: ', err);
            });
        }
    });
})(VerifyGiftCard || (VerifyGiftCard = {}));
